import React from 'react';

import styled from 'styled-components';

import { useAppSelector } from 'store/hook';

import SelectFilter from '../../lib/SelectFilter';
import { useCommunityViewContext } from '../CommunityViewContext';

const Label = styled.span`
  font-family: var(--font-bold);
`;

const HeaderViewFiltersCompare = () => {
  const { communityMap, competitors } = useAppSelector((state) => state.global);
  const { competitorId, communityId, setCommunityId, setViewFilters } = useCommunityViewContext();
  const competitor = competitorId ? competitors.find(_comp => _comp.id == competitorId) : null;

  const parentIds = competitor?.communities.length ? competitor.communities : [];

  const communtiesFilterOptions = parentIds
    .map((id) => {
      const community = communityMap[id];
      return {
        label: community?.comunity_name,
        value: community?.id,
        color: community?.color,
      };
    })
    .filter(Boolean);

  return (
    <SelectFilter
      className="active"
      placeholder={'Compare With'}
      options={communtiesFilterOptions}
      value={communityId}
      variant="borderless"
      onChange={(value: number) => {
        setCommunityId(value);
        setViewFilters((prevState: any) => ({ ...prevState, communities: [value] }));
      }}
      labelRender={({ label, value }) => {
        return <span><Label>Compare With: </Label>{label}</span>;
      }}
    />
  );
};

export default HeaderViewFiltersCompare;
